<template>
  <div>
    <date-range-picker
      class="date-range-picker rounded-lg"
      v-model="date"
      format="YYYY-MM-DD HH:mm:ss"
      time-title-format="YYYY-MM-DD HH:mm:ss"
      type="datetime"
      :lang="{
        formatLocale: {
          months: [
            'Ocak',
            'Şubat',
            'Mart',
            'Nisan',
            'Mayıs',
            'Haziran',
            'Temmuz',
            'Ağustos',
            'Eylül',
            'Ekim',
            'Kasım',
            'Aralık',
          ],
          monthsShort: [
            'Oca',
            'Şub',
            'Mar',
            'Nis',
            'May',
            'Haz',
            'Tem',
            'Ağu',
            'Eyl',
            'Eki',
            'Kas',
            'Ara',
          ],
          weekdays: [
            'Pazar',
            'Pazartesi',
            'Salı',
            'Çarşamba',
            'Perşembe',
            'Cuma',
            'Cumartesi',
          ],
          weekdaysShort: ['Paz', 'Pts', 'Sal', 'Çar', 'Per', 'Cum', 'Cts'],
          weekdaysMin: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
          firstDayOfWeek: 1,
          firstWeekContainsDate: 7,
        },
      }"
    />
  </div>
</template>

<script>
import DateRangePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import moment from "moment";

export default {
  name: "datepicker",
  data() {
    return {
      model: null,
      date: {
        startDate: new Date(),
      },
      opens: "right",
    };
  },
  components: {
    "date-range-picker": DateRangePicker,
  },
  props: ["input", "form", "value", "openType"],
  created() {
    if (this.value) {
      this.model = this.value;
    }
    if (this.openType) {
      this.opens = this.openType;
    }
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    date() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: moment(this.date).format("YYYY-MM-DD HH:mm:ss"),
      });
      this.$emit("changed", {
        name: this.input.name,
        value: moment(this.date).format("YYYY-MM-DD HH:mm:ss"),
      });
    },
  },
};
</script>

<style>
.daterangepicker.single.show-ranges {
  min-width: 370px !important;
}

.daterangepicker.show-ranges {
  min-width: 700px !important;
}

.mx-datepicker {
  width: 100% !important;

  box-shadow: none !important;
  border-color: #e5e5e5 !important;
}

.date-range-picker .reportrange-text {
  display: inline-block;
  vertical-align: middle;

  font-size: 13px;
  text-align: center;
  border: 0 none;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #fff;
  color: #666;
}
</style>
